import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import {typeToName} from 'util/NameUtil';

interface Props {
  type?: ModelTypeConstants;
  // Default is true, but set to false for the instructions editor. Controls whether the editor is rendered
  // with position: absolute.
  fullScreen?: boolean;
  isLocked: boolean;
}

export default function CollectibleBanner({type, fullScreen = true, isLocked}: Props): JSX.Element | null {
  if (!type) {
    return null;
  }
  return (
    <div className={classNames('collectible-banner', fullScreen && css(styles.fullScreen))}>
      <div className={css(styles.container)}>
        <span className={css(styles.centeredText)}>
          {isLocked ? 'Viewing' : 'Editing'} {typeToName(type)}
        </span>
        {/* TODO(BNCH-121599): Enable once link to created documents is completed */}
        {/* <span className={css(styles.leftLink)}>
          View {documentType} created from {type} <BenchlingIcon icon="arrow-right" />
        </span> */}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    textAlign: 'center',
  },
  centeredText: {
    margin: 'auto',
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    fontSize: '13px',
  },
  leftLink: {
    float: 'right',
    position: 'absolute',
    right: 0,
    paddingRight: '12px',
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    fontSize: '10px',
    height: '18px',
    alignContent: 'center',
  },
  fullScreen: {
    position: 'absolute',
  },
});
